module.exports = __webpack_public_path__ + "static/media/itacare-ba.b029bb91.jpg";